<template>
  <CheckFormBox
    :title="applicationType == 'FIRST' ? $t('message.DataRegistration.formData.drivers_data') : $t('message.DataRegistration.Driver.update_drivers_data')"
  >
    <div class="check_drivers" v-for="(item,index) in data" :key="index">
      <div class="check_drivers_title">{{driversNum(index,false)}}</div>

      <el-row :gutter="48">
        <!-- 中文姓名 -->
        <el-col v-if="applicationType == 'FIRST'" :xs="24" :sm="12">
          <div
            class="form_label"
          >{{lan != 'PT' ? driversNum(index) : '' + $t('message.DataRegistration.Driver.nameCn')}}{{lan == 'PT' ? driversNum(index) : $t('message.DataRegistration.Driver.nameCn')}}：</div>
          <div class="form_value">{{item.nameCn}}</div>
        </el-col>
        <!-- 外文姓名 -->
        <el-col v-if="applicationType == 'FIRST'" :xs="24" :sm="12">
          <div
            class="form_label"
          >{{lan != 'PT' ? driversNum(index) : '' + $t('message.DataRegistration.Driver.nameEn')}}{{lan == 'PT' ? driversNum(index) : $t('message.DataRegistration.Driver.nameEn')}}：</div>
          <div class="form_value">{{item.nameEn}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="48">
        <!-- 澳門居民身份證編號 -->
        <el-col v-if="applicationType == 'FIRST'" :xs="24" :sm="12">
          <div
            class="form_label"
          >{{lan != 'PT' ? driversNum(index) : '' + $t('message.DataRegistration.Driver.identityNo')}}{{lan == 'PT' ? driversNum(index) : $t('message.DataRegistration.Driver.identityNo')}}：</div>
          <div class="form_value">{{item.identityNo}}</div>
        </el-col>
        <!-- 性別 -->
        <el-col v-if="applicationType == 'FIRST'" :xs="24" :sm="12">
          <div
            class="form_label"
          >{{lan != 'PT' ? driversNum(index) : '' + $t('message.DataRegistration.Driver.sex')}}{{lan == 'PT' ? driversNum(index) : $t('message.DataRegistration.Driver.sex')}}：</div>
          <div
            class="form_value"
          >{{item.sex && sex.length > 0 ? sex.find(ele => ele.codeKey == item.sex)[$t('message.codeName')] : ''}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="48">
        <!-- 出生日期 -->
        <el-col v-if="applicationType == 'FIRST'" :xs="24" :sm="12">
          <div
            class="form_label"
          >{{lan != 'PT' ? driversNum(index) : '' + $t('message.DataRegistration.Driver.birthday')}}{{lan == 'PT' ? driversNum(index) : $t('message.DataRegistration.Driver.birthday')}}：</div>
          <div class="form_value">{{item.birthday | formatDT('dd/MM/yyyy')}}</div>
        </el-col>
        <!-- 國籍 -->
        <el-col v-if="applicationType == 'FIRST'" :xs="24" :sm="12">
          <div
            class="form_label"
          >{{lan != 'PT' ? driversNum(index) : '' + $t('message.DataRegistration.Driver.nationality')}}{{lan == 'PT' ? driversNum(index) : $t('message.DataRegistration.Driver.nationality')}}：</div>
          <div
            class="form_value"
          >{{item.nationality && (item.nationality == 'XXX' ? item.otherNationalityText : nationality.length > 0 ? nationality.find(ele => ele.codeKey == item.nationality)[$t('message.codeName')] : '')}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="48">
        <!-- 澳門駕駛文件類別 -->
        <el-col :xs="24" :sm="12">
          <div
            class="form_label"
          >{{lan != 'PT' ? driversNum(index) : '' + $t('message.DataRegistration.Driver.macauDrivingLicenseType')}}{{lan == 'PT' ? driversNum(index) : $t('message.DataRegistration.Driver.macauDrivingLicenseType')}}：</div>
          <div
            class="form_value"
          >{{item.macauDrivingLicenseType && drivingLicenseType.length > 0 ? drivingLicenseType.find(ele => ele.codeKey == item.macauDrivingLicenseType)[$t('message.codeName')] : ''}}</div>
        </el-col>
        <!-- 澳門駕駛文件編號 -->
        <el-col :xs="24" :sm="12">
          <div
            class="form_label"
          >{{lan != 'PT' ? driversNum(index) : '' + $t('message.DataRegistration.Driver.macauDrivingLicenseNo')}}{{lan == 'PT' ? driversNum(index) : $t('message.DataRegistration.Driver.macauDrivingLicenseNo')}}：</div>
          <div class="form_value">{{item.macauDrivingLicenseNo}}</div>
        </el-col>
      </el-row>
      <!-- 本澳流動電話 -->
      <el-row :gutter="48">
        <el-col v-if="applicationType == 'FIRST'" :xs="24" :sm="12">
          <div
            class="form_label"
          >{{lan != 'PT' ? driversNum(index) : '' + $t('message.DataRegistration.Driver.macauMobile')}}{{lan == 'PT' ? driversNum(index) : $t('message.DataRegistration.Driver.macauMobile')}}：</div>
          <div class="form_value">{{item.macauMobile ? '+853':''}} {{item.macauMobile}}</div>
        </el-col>
      </el-row>
      <!-- macauAddress -->
      <!-- 澳門聯絡地址 -->
      <el-row :gutter="48">
        <el-col v-if="applicationType == 'FIRST'" :span="24">
          <div
            class="form_label"
          >{{lan != 'PT' ? driversNum(index) : '' + $t('message.macauAddress.macauAddress')}}{{lan == 'PT' ? driversNum(index) : $t('message.macauAddress.macauAddress')}}：</div>
          <div class="form_value">{{item.macauAddress.textCn || item.macauAddress.textPt}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="48">
        <!-- 內地聯絡電話 -->
        <el-col :xs="24" :sm="12">
          <div
            class="form_label"
          >{{lan != 'PT' ? driversNum(index) : '' + $t('message.DataRegistration.Driver.mainlandPhone')}}{{lan == 'PT' ? driversNum(index) : $t('message.DataRegistration.Driver.mainlandPhone')}}：</div>
          <div class="form_value">{{item.macauMobile ? '+86':''}} {{item.mainlandPhone}}</div>
        </el-col>
        <!-- 內地電郵地址 -->
        <el-col :xs="24" :sm="12">
          <div
            class="form_label"
          >{{lan != 'PT' ? driversNum(index) : '' + $t('message.DataRegistration.Driver.mainlandEmail')}}{{lan == 'PT' ? driversNum(index) : $t('message.DataRegistration.Driver.mainlandEmail')}}：</div>
          <div class="form_value">{{item.mainlandEmail}}</div>
        </el-col>
      </el-row>
      <el-row v-if="ageCalculation(item.birthday) >= 70" :gutter="48">
        <!-- 內地駕照編號 -->
        <el-col :xs="24" :sm="12">
          <div
            class="form_label"
          >{{lan != 'PT' ? driversNum(index) : '' + $t('message.DataRegistration.Driver.mainlandDrivingLicenseNo')}}{{lan == 'PT' ? driversNum(index) : $t('message.DataRegistration.Driver.mainlandDrivingLicenseNo')}}：</div>
          <div class="form_value">{{item.mainlandDrivingLicenseNo}}</div>
        </el-col>
        <!-- 內地駕駛許可檔案編號 -->
        <el-col :xs="24" :sm="12">
          <div
            class="form_label"
          >{{lan != 'PT' ? driversNum(index) : '' + $t('message.DataRegistration.Driver.mainlandDrivingPermitNo')}}{{lan == 'PT' ? driversNum(index) : $t('message.DataRegistration.Driver.mainlandDrivingPermitNo')}}：</div>
          <div class="form_value">{{item.mainlandDrivingPermitNo}}</div>
        </el-col>
      </el-row>
    </div>
  </CheckFormBox>
</template>

<script>
import CheckFormBox from "./CheckFormBox";
import VssViewAPI from "../../../../api/VssViewAPI";
export default {
  props: ["data"],
  components: { CheckFormBox },
  data() {
    return {
      sex: [],
      nationality: [],
      drivingLicenseType: [],
    };
  },
  computed: {
    driversNum() {
      return function (index, showDe = true) {
        if (showDe) {
          return (
            this.$t("message.DataRegistration.formData.no") +
            this.$t(`message.capitalLetter[${index + 1}]`) +
            this.$t("message.DataRegistration.formData.driver_de")
          );
        } else {
          return (
            this.$t("message.DataRegistration.formData.no") +
            this.$t(`message.capitalLetter[${index + 1}]`) +
            this.$t("message.DataRegistration.formData.driver")
          );
        }
      };
    },
    applicationType() {
      const serviceType = this.$store.state.serviceType;
      return serviceType == "HZMB_FIRST_PERSON" ||
        serviceType == "HZMB_FIRST_COMPANY"
        ? "FIRST"
        : "RENEW";
    },
    lan() {
      return this.$i18n.locale;
    },
    ageCalculation() {
      return (birthday) => {
        const birthdays = new Date(birthday);
        let d = new Date();
        let age = null;
        if (birthday) {
          age =
            d.getFullYear() -
            birthdays.getFullYear() -
            (d.getMonth() < birthdays.getMonth() ||
            (d.getMonth() == birthdays.getMonth() &&
              d.getDate() < birthdays.getDate())
              ? 1
              : 0);
        }
        return age || 0;
      };
    },
  },
  created() {
    // 基礎數據
    Promise.all([
      VssViewAPI.getsexs(),
      VssViewAPI.getNationalitys(),
      VssViewAPI.getDrivingLicenseTypes(),
    ]).then((res) => {
      this.sex = res[0];
      this.nationality = res[1];
      // {
      //     codeCname: "其他",
      //     codeKey: "OTHER",
      //     codeMasterCname: "國籍",
      //     codeMasterPname: "other",
      //     codeMasterType: 0,
      //     codeOrder: 1,
      //     codePname: "其他",
      //     codeStatus: "A"
      //   }
      this.drivingLicenseType = res[2];
    });
  },
};
</script>

<style lang="scss" scoped>
.check_drivers {
  padding-bottom: 8px;
  margin-bottom: 24px;
  border-bottom: 1px solid rgba(50, 50, 50, 0.16);
}
.check_drivers:last-child {
  padding-bottom: 0px;
  border-bottom: 0;
}
.check_drivers_title {
  margin-bottom: 24px;
  font-size: 18px;
  font-weight: 500;
  color: rgba(50, 50, 50, 1);
  line-height: 25px;
}
</style>
